// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"2b5718ed","621":"ed39aae1","724":"7a2fee7d","787":"323d39fc","809":"f3dbbe1b","847":"02347939","985":"3c43cfef"}[chunkId] + ".chunk.js";
};